import React, { useEffect, useState } from "react";
import Style from './WorkingHours.module.css';
import Checkbox from '../../../components/controls/checkbox/Checkbox'
import DropDown from "../../../components/controls/dropdown/Dropdown";
import { workingHours } from '../../../helpers/utils';

const WorkingHoursItem = (props) => {
    const { index, item, handleItemChange } = props;
    const [checked, setChecked] = useState(item.dayOff);
    const [startTime, setStartTime] = useState(item.startTime);
    const [endTime, setEndTime] = useState(item.endTime);

    const handleCheckboxChange = () => {
        setChecked(!checked);
        item.dayOff = !checked;
        const newItem = { ...item, dayOff: !checked, startTime: "00:00:00", endTime: "00:00:00" };
        handleItemChange(index, newItem);
    };

    const getWeekDay = () => {
        switch (item.weekDay) {
            case 0: return 'MON';
            case 1: return 'TUE';
            case 2: return 'WED';
            case 3: return 'THU';
            case 4: return 'FRI';
            case 5: return 'SAT';
            case 6: return 'SUN';
            default: return '';
        }
    }

    useEffect(() => {
        const newItem = { ...item, startTime, endTime };
        handleItemChange(index, newItem);
    }, [startTime, endTime]);

    const convertTimeToAMPM = (val) => {
        const [hours, minutes] = val.split(':');
        const time = new Date(0, 0, 0, hours, minutes);
        const options = { hour: 'numeric', minute: 'numeric', hour12: true };
        return time.toLocaleString('en-US', options);
    }

    return (
        <div className={Style.dayWrapper}>
            <div className="d-flex justify-content-between align-items-center">
                <div className={Style.radioBtnWrapper}>
                    <Checkbox label={getWeekDay()} checked={!checked} setChecked={handleCheckboxChange} />
                </div>  
            </div>
            <div className="d-flex justify-content-between align-items-center">
                {checked ?
                    <p className={Style.unavailableTitle} >Unavailable</p>
                    :
                    (
                        <div className={Style.dropDownWrapper}>
                            <div>
                                <DropDown options={workingHours} selectedOption={item.startTime.slice(0, -3)} changeHandler={setStartTime} />
                            </div>
                            <div className={Style.seperator}>-</div>
                            <div>
                                <DropDown options={workingHours} selectedOption={item.endTime.slice(0, -3)} changeHandler={setEndTime} />
                            </div>
                        </div>
                    )
                }
            </div>
        </div>
    );
}

export default WorkingHoursItem;